import React from "react";
import { Map } from "immutable";

import Boolean from "./DataTypes/Boolean";
import False from "./DataTypes/Boolean/False";
import True from "./DataTypes/Boolean/True";
import Date from "./DataTypes/Date";
import DateTime from "./DataTypes/DateTime";
import Number from "./DataTypes/Number";
import Float from "./DataTypes/Number/Float";
import Integer from "./DataTypes/Number/Integer";
import Time from "./DataTypes/Time";
import Text from "./DataTypes/Text";
import URL from "./DataTypes/Text/URL";
import Button from "./Button";
import Class from "./Class";

const byPropertyName = Map();

const byRangeClassName = Map({
  Boolean,
  False,
  True,
  Date,
  DateTime,
  Number,
  Float,
  Integer,
  Time,
  Text,
  URL
});

const decorate = (Component, { property, type, ...initialProps }) => ({
  onClick,
  ...props
}) => (
  <div {...props}>
    <Button onClick={onClick} />
    <Component
      type={type}
      {...initialProps}
      {...props}
    />
  </div>
);

const PropertyInstanceFactory = (property, type, defaultValue = null) => {
  if (byPropertyName.has(property.name))
    return decorate(byPropertyName.get(property.name), {
      property,
      type,
      defaultValue
    });

  if (byRangeClassName.has(type))
    return decorate(byRangeClassName.get(type), {
      property,
      type,
      defaultValue
    });

  return decorate(Class, { property, type, defaultValue });
};

export default PropertyInstanceFactory;
